<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useConfirm, useToast } from 'primevue'
import { usePushCampaignListStore } from '@/modules/push-campaign/stores/push-campaign.list.store.ts'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { PushCampaignAPI } from '../constants/push-campaign.api.uri.const'
import { useUpdateUrlParam } from '@/composables/useReactiveQueryParam'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  cellConfig: {
    type: Object,
    default: () => ({}),
  },
  tableConfig: {
    type: Object,
    default: () => ({}),
  },
})

const confirm = useConfirm()
const toast = useToast()
const pushCampaignListStore = usePushCampaignListStore()
const { updateUrlParam } = useUpdateUrlParam()

const handleGotoDetail = async () => {
  const id = Number(props.data.id)
  if (!Number.isFinite(id) || id <= 0) return
  try {
    const res = (await APIClient.get(
      PushCampaignAPI.campaign.detail.replace(':id', String(id)),
    )) as unknown

    const get = (obj: unknown, keys: string[]): unknown => {
      let cur: unknown = obj
      for (const k of keys) {
        if (!cur || typeof cur !== 'object') return undefined
        cur = (cur as Record<string, unknown>)[k]
      }
      return cur
    }

    const dto = (get(res, ['data', 'data', 'data']) ?? get(res, ['data', 'data']) ?? get(res, ['data']) ?? res) as
      | Record<string, unknown>
      | undefined

    const title = (dto?.title as string | undefined) ?? `#${id}`
    pushCampaignListStore.newTab({
      id,
      label: `#${id} - ${title}`,
      active: true,
    })
  } catch {
    pushCampaignListStore.newTab({
      id,
      label: `#${id}`,
      active: true,
    })
  } finally {
    updateUrlParam('detailId', String(id))
  }
}

const handleCancelCampaign = () => {
  confirm.require({
    message: 'Bạn có muốn huỷ kế hoạch chiến dịch này?',
    header: 'Xác nhận',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true,
    },
    acceptProps: {
      label: 'Đồng ý',
    },
    accept: async () => {
      try {
        await pushCampaignListStore.stopCampaign(props.data.id)
        toast.add({
          severity: 'success',
          summary: 'Thành công',
          detail: 'Huỷ kế hoạch thành công',
          life: 3000,
        })
      } catch {
        toast.add({
          severity: 'error',
          summary: 'Lỗi',
          detail: 'Huỷ kế hoạch thất bại',
          life: 3000,
        })
      }
    },
    reject: () => {},
  })
}
</script>

<template>
  <div class="flex gap-2">
    <button type="button" class="btn btn-cs flex items-center gap-1 whitespace-nowrap" @click="handleGotoDetail">
      <Icon icon="iconamoon:edit-duotone" />
      Chi tiết
    </button>
    <button
      v-if="props.data.schedule_type && props.data.schedule_type !== 'now'"
      type="button"
      class="btn btn-danger !px-[12px] !py-[5px] bg-hover-danger text-white flex items-center gap-1 whitespace-nowrap"
      @click="handleCancelCampaign"
    >
      <Icon icon="mdi:stop-circle-outline" />
      Huỷ kế hoạch
    </button>
  </div>
</template>
